import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { API_ROUTES, facebookAppId } from '../../../../utils/constants';

const fbIcon = require('../../../../assets/images/AuthFlow/LoginWithFacebook.png');

class FacebookLoginButton extends Component {
    static propTypes = {
      login: PropTypes.func.isRequired,
    }

    responseFacebook = (response) => {
      if (response && response.accessToken) {
        this.props.login({ route: API_ROUTES.FACEBOOK_LOGIN, token: response.accessToken });
      }
    }

    render() {
      return (
        <React.Fragment >
          <FacebookLogin
            appId={facebookAppId}
            fields="name,email,picture"
            callback={this.responseFacebook}
            render={renderProps => (
              <button className="facebook_btn_login" onClick={renderProps.onClick}>
                <img src={fbIcon} alt="Facebook logo" />
              </button>
          )}
          />
        </React.Fragment>);
    }
}

export default FacebookLoginButton;



// WEBPACK FOOTER //
// ./src/containers/SocialLoginWrapper/components/FacebookLogin/FacebookLogin.js